import { Stack } from '@mui/material';
import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import { useSMSTotalsSearch } from '../../sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import PasswordlessAuthenticationContent from './passwordless-authentication-content/passwordless-authentication-content.component';
import PasswordlessAuthenticationSummaryHeader from './passwordless-authentication-summary-header/passwordless-authentication-summary-header.component';

const PasswordlessAuthentication = () => {
  const { refetchSMSTotals } = useSMSTotalsSearch('PASSWORDLESS_AUTH');

  return (
    <IncPageBody>
      <SearchToolbar
        excludedFilters={['storeIds']}
        onRefreshClick={refetchSMSTotals}
      />
      <Stack mt={2} spacing={2}>
        <PasswordlessAuthenticationSummaryHeader />
        <PasswordlessAuthenticationContent />
      </Stack>
    </IncPageBody>
  );
};

export default PasswordlessAuthentication;
